import axios from 'axios'
import store from '@/store'

const dataApi = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL
})

dataApi.interceptors.request.use( (config)=> {
    const token = store.state.token
    config.headers['Authorization'] = `Bearer ${token}`;
   // config.params['blah-defaut-param'] = 'blah-blah-default-value';
    return {
        ...config
      };
})
 
export default dataApi